// @ts-nocheck

// @index('./*.vue', (f, _) => `import { default as Book${_.pascal(f.name)} } from '${f.path}${f.ext}'`)
import { default as BookActions } from './actions.vue'
import { default as BookBanner } from './banner.vue'
import { default as BookBasic } from './basic.vue'
import { default as BookClosed } from './closed.vue'
import { default as BookComment } from './comment.vue'
import { default as BookCoupon } from './coupon.vue'
import { default as BookGoods } from './goods.vue'
// @endindex

export const BookBlocks = {
  // @index('./*.vue', (f, _) => `Book${_.pascal(f.name)},`)
  BookActions,
  BookBanner,
  BookBasic,
  BookClosed,
  BookComment,
  BookCoupon,
  BookGoods,
  // @endindex
}
